import { TextField } from "@shared/components/TextField";
import { useFormContext } from "react-hook-form";
import { SubscriptionFlowChangeEmailSchema } from "./subscription-flow-change-email-form-helpers";
import { Form } from "@shared/components/Form";
import { Button, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { SubmitButton } from "@avenue-8/sidekick-ui";

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;

  ${(p) => p.theme.media.mobileDown} {
    button {
      flex: 1;
    }
  }
`;

type Props = {
  handleStartChangeSubscriptionEmail: (data: {
    email: string;
  }) => Promise<void>;
  status: "idle" | "pending" | "success" | "error";
  onCancel: () => void;
  currentEmail: string;
};

export const SubscriptionFlowChangeEmailForm = (props: Props) => {
  const { handleStartChangeSubscriptionEmail, status, currentEmail, onCancel } =
    props;
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setError,
  } = useFormContext<SubscriptionFlowChangeEmailSchema>();

  const onSubmit = async (data: SubscriptionFlowChangeEmailSchema) => {
    if (data.email === currentEmail) {
      setError("email", {
        type: "manual",
        message: "The new e-mail must be different from the current one",
      });
      return;
    }
    await handleStartChangeSubscriptionEmail({
      email: data.email,
    });
    reset();
  };

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      aria-disabled={status === "pending"}
    >
      <Typography mb={3} variant="body2" color="primary">
        You have the option to use a different email address for your Sidekick
        account.
      </Typography>
      <TextField
        label="Current e-mail"
        name="current-email"
        InputProps={{ readOnly: true }}
        value={currentEmail}
        disabled={status === "pending"}
      />
      <TextField
        label="Preferred Account E-mail"
        name="email"
        inputProps={{ ...register("email") }}
        fieldError={errors.email}
        disabled={status === "pending"}
      />

      <ActionsContainer>
        <Button
          onClick={onCancel}
          variant="text"
          disabled={status === "pending"}
        >
          Cancel
        </Button>
        <SubmitButton isLoading={status === "pending"}>Confirm</SubmitButton>
      </ActionsContainer>
    </Form>
  );
};
